import React from "react";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  Paper,
  Snackbar,
  Switch,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import axios from "../../../../api/axios";
import {
  CEPInput,
  DocumentInput,
  EmailInput,
  MoneyInput,
  PhoneInput,
  SelectComponent,
  SwitchComponent,
  TextFieldComponent,
} from "../../../../components/misc/form";
import MediaUpload from "../../../../components/mediaUpload";
import useAlert from "../../../../globalComponents/useAlerts";
import { unmaskMoney } from "../../../../functions";

const CreateCustomer = () => {
  const { showLoading, showAlert, dismissLoading } = useAlert();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit: formSubmit,
    control,
    setValue,
    setFocus,
    watch,
  } = useForm();
  const [loading, setLoading] = useState(false);

  const refs = {};

  const handleSubmit = async (form) => {
    try {
      showLoading();
      if (!form.imageFile) throw new Error("Adiciona uma imagem ao produto!");

      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        formData.append(key, form[key]);
      });

      const data = await axios.postForm("/products", formData);

      if (!data)
        throw new Error(
          "Não foi possível registrar produto. Verifique os parâmetros e tente novamente!",
        );

      setTimeout(() => navigate("./../" + data._id), 1500);
    } catch (err) {
      showAlert({ title: "Atenção", description: err.message });
    } finally {
      dismissLoading();
      setLoading(false);
    }
  };

  const onUploadComplete = React.useCallback(([file]) => {
    setValue("imageFile", file);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh", // full screen
        //=display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: 30,
      }}
    >
      <Typography variant="h4" gutterBottom>
        Cadastro de Produto
      </Typography>

      <Paper
        elevation={3}
        sx={{
          //width: 400,
          maxHeight: "80vh", // limit height
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          onSubmit={formSubmit(handleSubmit)}
          component="form"
          sx={{
            p: 2,
            overflowY: "auto", // 🔥 enables scroll
            flex: 1, // fills available space
          }}
        >
          <Grid container spacing={2} mt={1}>
            <Typography variant="h6" mt={1}>
              Dados do Produto
            </Typography>
            <Grid container size={{ xs: 12 }}>
              <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                <Paper
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "5px",
                  }}
                >
                  <MediaUpload
                    forwardRef={(ref) => (refs.imageUrl = ref)}
                    onUploadComplete={onUploadComplete}
                    acceptTypes=".jpeg,.jpg,.png,.webp,"
                    style={{ maxHeight: 100 }}
                  >
                    {({ onUploadRequest, media }) => (
                      <Button onClick={onUploadRequest}>
                        <div>
                          {media.thumbnail || (
                            <Icon
                              style={{
                                fontSize: 150,
                                alignSelf: "center",
                                color: "#ccc",
                              }}
                            >
                              add_photo_alternate
                            </Icon>
                          )}
                        </div>
                      </Button>
                    )}
                  </MediaUpload>
                </Paper>
              </Grid>

              <Grid container size={{ xs: 12, md: 8, lg: 8 }}>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                  <TextFieldComponent
                    name="title"
                    control={control}
                    label={"Título"}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                  <TextFieldComponent
                    maxRows={6}
                    minRows={6}
                    multiline
                    name="description"
                    control={control}
                    label={"Descrição"}
                    fullWidth
                    required
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <Button
              loading={loading}
              variant="contained"
              color="primary"
              type="submit"
              sx={{ mt: 3 }}
            >
              Salvar
            </Button>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default CreateCustomer;
